import { LIST_SIZE_ENDPOINT } from 'api/ListsApi';
import { isDefined } from 'utils/tsHelpers';
import { useRestQuery } from 'utils/hooks/api';

export const useListSizeByIdQuery = (id: number | undefined, isEnabled = true) => {
  const { data = {}, isLoading } = useRestQuery(
    LIST_SIZE_ENDPOINT,
    { listId: id },
    { enabled: isEnabled && isDefined(id), refetchOnWindowFocus: false },
  );

  return {
    size: data?.size,
    isLoading,
  };
};
